import { toSeconds } from '@/helpers/toSeconds';
import { shortenTime } from '@/helpers/shortenTime';

export function getLinkedMyFirework(event, firework_store) {
	if (event?.my_firework_id == undefined) return null;
	return firework_store?.my_fireworks?.find((f) => f.firework_ID == event.my_firework_id) ?? null;
}

export function getMyFireworkOutOfSyncFields(event, firework_store) {
	const firework = getLinkedMyFirework(event, firework_store);
	if (firework == null) return [];

	const fields = [];

	// Description (name)
	const firework_name = firework.name != undefined && firework.name !== '' ? firework.name : undefined;
	const event_name = event.firework_name != undefined && event.firework_name !== '' ? event.firework_name : undefined;
	if (event_name !== firework_name) fields.push('description');

	// Treat 0, null, and undefined as equivalent so events missing numeric fields
	// aren't flagged as out-of-sync against fireworks with no lift/duration set.
	const firework_duration_seconds = firework.duration != undefined ? toSeconds(firework.duration) : undefined;
	const event_duration = event.duration_in_seconds == undefined || event.duration_in_seconds == 0 ? undefined : event.duration_in_seconds;
	const normalized_firework_duration = firework_duration_seconds == undefined || firework_duration_seconds == 0 ? undefined : firework_duration_seconds;
	if (event_duration !== normalized_firework_duration) fields.push('duration');

	const firework_lift_seconds = firework.lift_time != undefined ? toSeconds(firework.lift_time) : undefined;
	const event_lift = event.lift_time_in_seconds == undefined || event.lift_time_in_seconds == 0 ? undefined : event.lift_time_in_seconds;
	const normalized_firework_lift = firework_lift_seconds == undefined || firework_lift_seconds == 0 ? undefined : firework_lift_seconds;
	if (event_lift !== normalized_firework_lift) fields.push('lift_time');

	return fields;
}

export function isMyFireworkOutOfSync(event, firework_store) {
	return getMyFireworkOutOfSyncFields(event, firework_store).length > 0;
}

export function syncEventToMyFirework(event, firework) {
	if (event == undefined || firework == undefined) return;

	if (firework.name != undefined) {
		event.firework_name = firework.name;
		event.event_description = firework.name;
	}
	if (firework.duration != undefined) {
		event.duration = shortenTime(firework.duration);
		event.duration_in_seconds = toSeconds(firework.duration);
	} else {
		event.duration = undefined;
		event.duration_in_seconds = undefined;
	}
	if (firework.lift_time != undefined) {
		event.lift_time = shortenTime(firework.lift_time);
		event.lift_time_in_seconds = toSeconds(firework.lift_time);
	} else {
		event.lift_time = undefined;
		event.lift_time_in_seconds = undefined;
	}
}
